/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agents_SubtitleInputs */

const en_home_agents_subtitle = /** @type {(inputs: Home_Agents_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every menu item, tool and prompt in CADCraft is a command. Agents type at the command line like a person, call any command with JSON, inspect the drawing and render the result.`)
};

/**
* | output |
* | --- |
* | "Every menu item, tool and prompt in CADCraft is a command. Agents type at the command line like a person, call any command with JSON, inspect the drawing and..." |
*
* @param {Home_Agents_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_agents_subtitle = /** @type {((inputs?: Home_Agents_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agents_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_agents_subtitle(inputs)
});
export { home_agents_subtitle as "home.agents.subtitle" }